import { SUB_DOMAIN } from '@/constants/domain';

import { WEBVIEW_TYPE } from './webviewType';

const PARTNER_SUB_DOMAINS: (SUB_DOMAIN | null | undefined)[] = [
  SUB_DOMAIN.KB_PAY,
  SUB_DOMAIN.TOSS,
  SUB_DOMAIN.KAKAOBANK,
];

//* 서버는 웰로 웹 토큰을 앱과 구분하지 못한다 — 막을 대상은 제휴 셸(UA 또는 서브도메인)뿐이다
export const resolvePartnerWebviewGate = ({
  isMounted,
  webviewType,
  subDomain,
}: {
  isMounted: boolean;
  webviewType?: WEBVIEW_TYPE;
  subDomain?: SUB_DOMAIN | null;
}) => {
  if (!isMounted) {
    return 'CHECKING' as const;
  }

  const isPartnerWebview =
    (webviewType !== undefined && webviewType !== WEBVIEW_TYPE.WELLO_APP) ||
    PARTNER_SUB_DOMAINS.includes(subDomain);

  return isPartnerWebview ? ('PARTNER' as const) : ('ALLOWED' as const);
};
